import script from "./NoticeDetailDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticeDetailDialog.vue?vue&type=script&setup=true&lang=js"

import "./NoticeDetailDialog.vue?vue&type=style&index=0&id=328d5eff&lang=css"

const __exports__ = script;

export default __exports__